const LOCAL_MEMORY_MEDIA_PREFIX = 'http://localhost/media-assets/'

export function resolvePublicMediaUrl(url: string): string {
  if (!url.startsWith(LOCAL_MEMORY_MEDIA_PREFIX)) return url
  return `/api/media/assets/${url.slice(LOCAL_MEMORY_MEDIA_PREFIX.length)}`
}
